import { type IDictionaryDisplayElement } from "@tedivo/tedivo-ui";
import { i18n } from "./i18tn";

export default function getDisplayValue(el: IDictionaryDisplayElement): string | HTMLElement {
  switch (el.type) {
    case "yesNo":
      return el.value
        ? i18n.t("general:common.yes")
        : i18n.t("general:common.no");
      break;
    case "HtmlElement":
      return el.value;
    default:
      return el.value !== undefined && el.format
        ? el.format(el.value)
        : String(el.value);
  }
}
